import React from "react";
import { Card, CardContent, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAuth } from "context/AuthContext";
import { motion } from "framer-motion";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function RolesAssignWarningPage() {
  const { logout } = useAuth();

  const handleBackToLogin = () => {
    logout();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
    <div
      style={{
        // minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "170px",
        // background: "linear-gradient(135deg, #f8fafc, #eef2ff)",
      }}
    >
      {/* Page Animation */}
      <motion.div
        initial={{ opacity: 0, y: 40, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <Card
          component={motion.div}
          whileHover={{ y: -6 }}
          transition={{ type: "spring", stiffness: 120 }}
          sx={{
            maxWidth: 480,
            textAlign: "center",
            padding: "32px 24px",
            borderRadius: "20px",
            backdropFilter: "blur(10px)",
            background: "rgba(255,255,255,0.85)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
            border: "1px solid rgba(0,0,0,0.04)",
          }}
        >
          <CardContent>
            {/* Floating Icon */}
            <motion.div
              animate={{ y: [0, -8, 0] }}
              transition={{ repeat: Infinity, duration: 2.5, ease: "easeInOut" }}
            >
              <WarningAmberIcon
                sx={{
                  fontSize: 64,
                  color: "#f59e0b",
                  mb: 2,
                  filter: "drop-shadow(0px 6px 12px rgba(245,158,11,0.35))",
                }}
              />
            </motion.div>

            <h2 style={{ marginBottom: 8, fontWeight: 600 }}>
              Access Not Assigned Yet
            </h2>

            <p style={{ color: "#64748b", marginBottom: 20, fontSize: 15 }}>
              Your account is active, but you are not linked to any property or role yet.
            </p>

            {/* Info Box */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
              style={{
                background: "#fff7ed",
                color: "#9a3412",
                padding: "14px",
                borderRadius: "10px",
                fontSize: "14px",
                marginBottom: "24px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.03)",
              }}
            >
              Please contact your manager or administrator to assign you to a property so you can continue.
            </motion.div>

            {/* Button */}
            <motion.div whileTap={{ scale: 0.96 }}>
              <Button
                variant="contained"
                fullWidth
                startIcon={<ArrowBackIcon />}
                onClick={handleBackToLogin}
                sx={{
                  borderRadius: "12px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "15px",
                  padding: "10px",
                  background:
                    "linear-gradient(135deg, #f59e0b, #f97316)",
                  boxShadow: "0 10px 25px rgba(249,115,22,0.35)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #f97316, #ea580c)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 14px 30px rgba(249,115,22,0.45)",
                  },
                }}
              >
                Back to Sign In
              </Button>
            </motion.div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
    <Footer />
    </DashboardLayout>
  );
}

export default RolesAssignWarningPage;
